module.exports = __webpack_public_path__ + "static/bootstrap-image-fluid-eb7fb447b966f534968943ef0418078b.png";